import {DialogContent, Stack, Typography} from '@mui/material';
import {BaseDialog} from '@resurs-internal/mui';
import {useDialog, useTranslate} from 'hooks';
import React from 'react';
import digitalInvoiceImage from 'assets/images/digital-invoice.png';
import {useConsents} from '@resurs-internal/rb-app-api';
import {useQuery} from '@tanstack/react-query';

export const DigitalInvoiceNotificationForceDialog = () => {
  const translate = useTranslate();
  const dialog = useDialog('digital-invoice-notification-force');
  const consents = useConsents();
  const consent = consents.query.data?.consents?.find(
    (c) => c.externalId === 'Communication MyPages',
  );

  useQuery({
    queryKey: ['digital-invoice-notification-force-consent-status'],
    enabled: dialog.open && consent && consent?.status !== 'APPROVED',
    queryFn: async () => {
      if (!consent) return;
      await consents.update.mutateAsync({consent: consent, approve: true});
    },
  });

  return (
    <BaseDialog
      open={dialog.open}
      maxWidth={'sm'}
      image={digitalInvoiceImage}
      actions={[
        {
          title: translate('digital.invoice.notification.force.confirm'),
          onClick: dialog.onClose,
          color: 'primary',
        },
      ]}>
      <DialogContent>
        <Stack alignItems={'center'} gap={2}>
          <Typography typography={'h2'}>
            {translate('digital.invoice.notification.force.title')}
          </Typography>
          <Typography sx={{'white-space': 'pre-line'}} typography={'body1'}>
            {translate('digital.invoice.notification.force.subtitle')}
          </Typography>
        </Stack>
      </DialogContent>
    </BaseDialog>
  );
};
